"use strict";

const { default: Axios } = require("axios");

const Estancorp = function () {

    const opporunitiesNav = function () {

        let element = $(this);

        let id = element.val();
        let name = element.attr('name');

        let href = element.data('href');
        let request = element.data('request');

        let redirect = href + "?";

        if (Object.keys(request).length == 0) {
            request = {};
        }

        request[name] = id;

        redirect += $.param(request);

        window.location.href = redirect;

        // Axios.post(href, { 'id': id })
        //     .then(function (response) {
        //         let data = response.data;

        //         if (data.error == false) {
        //             $('.response-opportunity-nav-' + key).html(data.result.html);
        //             $('.select2').select2();
        //         }
        //     });
    }

    return {
        init: function () {
            $(document).on('change', '.act-opportunity-nav-ajax', opporunitiesNav);
        }
    }

}();

module.exports = Estancorp;